import { workspace } from '../../shared/api';
import { MedicalCertificate, MedicalCertificateDTO } from '../../interfaces/medicalCertificate';

export const MedicalCertificateService = {
  async create(prescriptionId: number, data: MedicalCertificateDTO): Promise<MedicalCertificate> {
    const payload: Partial<MedicalCertificate> = {
      CampoLivre: data.isFreeText,
      DataAtestado: data.medicalCertificateDate,
      DataInicio: data.startDate,
      DataTermino: data.endDate,
      Periodo: data.period,
      Observacao: data.observation,
      Texto: data.text,
      TipoPeriodo: data.restPeriodType,
      DeclaracaoComparecimento: data.isDeclarationOfAttendance,
      Tipo: data.type,
      CID10EstruturadoSecundarios: data.secondaryIcds.map((icd) => ({
        Codigo: icd.subcategory,
        idCID10: icd.id,
        Descricao: icd.description,
      })),
    };

    if (data.icd !== null) {
      payload.TextoConsentimento = data.consentText;
      payload.ConsentimentoCID = true;
      payload.CID10Estruturado = [
        {
          Codigo: data.icd.subcategory,
          idCID10: data.icd.id,
          Descricao: data.icd.description,
        },
      ];
    } else {
      payload.CID10Estruturado = [];
    }

    const response = await workspace.post('/prescricao/atestado', { ...payload, idPrescricao: prescriptionId });

    return response.data;
  },

  async delete(medicalCertificateId: number) {
    const payload = {
      idPrescricaoAtestado: medicalCertificateId,
    };

    const { data } = await workspace.delete('/prescricao/atestado', { data: payload });
    return data;
  },
  async update(prescriptionId: number, data: MedicalCertificateDTO): Promise<MedicalCertificate> {
    const payload: Partial<MedicalCertificate> = {
      CampoLivre: data.isFreeText,
      DataAtestado: data.medicalCertificateDate,
      DataInicio: data.startDate,
      DataTermino: data.endDate,
      Periodo: data.period,
      Observacao: data.observation,
      Texto: data.text,
      TipoPeriodo: data.restPeriodType,
      idPrescricaoAtestado: data.medicalCertificateId,
      DeclaracaoComparecimento: data.isDeclarationOfAttendance,
      CID10EstruturadoSecundarios: data.secondaryIcds.map((icd) => ({
        Codigo: icd.subcategory,
        idCID10: icd.id,
        Descricao: icd.description,
      })),
    };

    if (data.icd !== null) {
      payload.TextoConsentimento = data.consentText;
      payload.ConsentimentoCID = true;
      payload.CID10Estruturado = [
        {
          Codigo: data.icd.subcategory,
          idCID10: data.icd.id,
          Descricao: data.icd.description,
        },
      ];
    } else {
      payload.CID10Estruturado = [];
    }

    const response = await workspace.put(`/prescricao/atestado`, { ...payload, idPrescricao: prescriptionId });
    return response.data;
  },
};
